import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=50a4e470&scoped=true"
import script from "./createForm.vue?vue&type=script&lang=js"
export * from "./createForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4e470",
  null
  
)

export default component.exports